import {Post} from '../../libs/request'
import router from '../../router'

const state = {
  heartbeat: null,
  platformMessage: null,
  notificationNumber: null,
  orderLawyer: null
}
const getters = {
  getHeartbeat: state => state.heartbeat,
  getPlatformMessage: state => state.platformMessage,
  getNotificationNumber: state => state.notificationNumber,
  getOrderLawyer: state => state.orderLawyer
}

const mutations = {
  setHeartbeat (state) { state.heartbeat = new Date },
  setPlatformMessage (state, platformMessage) { state.platformMessage = platformMessage },
  setNotificationNumber (state, notificationNumber) { state.notificationNumber = notificationNumber },
  setOrderLawyer (state, orderLawyer) { state.orderLawyer = orderLawyer }
}

/**
 * 去支付或者结束
 * @param orderId
 */
function goPaymentByDuration (orderId) {
  if (router.history && router.history.current && router.history.current.path === '/PayWaiting') {
    return
  }
  router.replace({name: 'PayWaiting', params: {id: orderId}})
}

/**
 * 未接通
 */
// function goUnlink (id) {
//
//   // if (router.history && router.history.current && router.history.current.path === '/UnconnectedCause') {
//   //   return
//   // }
//   // router.replace({name: 'UnconnectedCause', params: {id: id}})
// }
//
// const LinkStatus = {
//   UnLinked: '0',
//   Linked: '1'
// }

function checkGoWhere (message) {
  if (message && message.orderId) {
    // if (message.isLinked === LinkStatus.Linked ||
    //   message.isLinked + '' === LinkStatus.Linked
    // ) {
    //
    //   return
    // }
    goPaymentByDuration(message.orderId)
    // goUnlink(message.orderId)
  }
}

const actions = {
  goPay ({commit}, message) {
    // {"status":6,"userId":"584","payType":2,"sourceChannel":"czh","orderId":"3558","orderFee":0.0}
    checkGoWhere(message)
  },

  async getPaymentByDuration ({commit}, data) {
    const res = await Post.getPaymentByDuration(data)
    // {
    //   "status" : 6,
    //   "memberPay" : true,
    //   "resultCode" : "1",
    //   "connectTimeInfo" : null,
    //   "layerInfo" : {
    //   "skilledFields" : "1,2,3",
    //     "lawOffice" : "上海衡量律师事务所",
    //     "layerName" : "刘律师",
    //     "headImgPath" : "https://doc.51ljb.cn/headPicImg1532921348409"
    // },
    //   "memberDeduction" : 0.0,
    //   "orderFee" : 0.0
    // }
    let obj = res.data
    if (obj) {
      obj = Object.assign(obj, data)
      // checkGoWhere(obj);
      commit('setPaymentByDuration', obj)
    }

    console.log(' getPaymentByDuration  obj  ', obj)
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}

export {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/websocket.js